import React from 'react';

const AdviserContext = React.createContext({

    infoCotizaciones: null,
    dateRange: null,
    productScope: [],
    cotizaciones: null,
    emisiones: null,
    modified: false,
    isReady: false

});

export default AdviserContext;